var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-floating"},[_c('div',{staticClass:"top-image"},[_c('div',{staticClass:"gambar-kartu"},[_c('img',{staticClass:"image-card",attrs:{"src":"assets/images/v284_1261.png","alt":"illustration"}})]),_c('div',{staticClass:"text-kartu"},[_c('p',{staticClass:"card-title paragraf4"},[_vm._v("Pengakuan atas Eksistensi Keberadaan ORMAS")])])])])
}]

export { render, staticRenderFns }